<template>
    <v-dialog v-model="exportInvoiceCloneDialog" max-width="1000px">
        <v-card>
            <v-card-title> {{ "Make a duplicate of" | t }} "{{ previousId }}"</v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col>
                            <v-text-field
                                :label="'Percent' | t"
                                :value="activeExportInvoice.percent"
                                append-icon="fa fa-percentage"
                                class="ma-0"
                                dense
                                hide-details
                                outlined
                                @input="updateField($event, 'percent')"
                            ></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field
                                :label="'Comment' | t"
                                :value="activeExportInvoice.comment"
                                class="ma-0"
                                dense
                                hide-details
                                outlined
                                @input="updateField($event, 'comment')"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col>
                            <v-combobox
                                v-model="client"
                                :items="export_clients"
                                :loading="isLoading"
                                :placeholder="'Client' | t"
                                class="text-field-item mb-1"
                                clearable
                                dense
                                hide-details
                                hide-no-data
                                hide-selected
                                item-text="name"
                                item-value="id"
                                outlined
                                @change="saveClientInfo"
                            ></v-combobox>
                        </v-col>
                        <v-col>
                            <v-autocomplete
                                v-model="manager"
                                :items="users"
                                :loading="isLoading"
                                :placeholder="'Manager' | t"
                                class="mb-1"
                                clearable
                                dense
                                hide-details
                                hide-no-data
                                hide-selected
                                item-text="name"
                                item-value="id"
                                outlined
                                return-object
                                @change="saveManagerInfo"
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row>
                        <v-col>
                            <label for="invoiceDate">{{ "Invoice date" | t }}</label>
                            <date-picker
                                id="invoiceDate"
                                v-model="invoiceDate"
                                :popover="{ placement: 'bottom', visibility: 'click' }"
                                is-inline
                            />
                        </v-col>
                        <v-col>
                            <label for="arrivalDate">{{ "Arrival date" | t }}</label>
                            <date-picker
                                id="arrivalDate"
                                v-model="arrivalDate"
                                :popover="{ placement: 'bottom', visibility: 'click' }"
                                is-inline
                            />
                        </v-col>
                        <v-col>
                            <label for="arrivalDate">{{ "Payroll date" | t }}</label>
                            <date-picker
                                v-model="payrollDate"
                                :popover="{ placement: 'bottom', visibility: 'click' }"
                                is-inline
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="bal-red darken-1" text @click="handleCancelClick">{{ "Back" | t }}</v-btn>
                <v-btn
                    :disabled="!activeExportInvoice.invoice_date"
                    color="bal-red darken-1"
                    text
                    @click="handleCloneClick"
                    >{{ "Duplicate" | t }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Store from "../../store";
import moment from "moment";
import DatePicker from "v-calendar/lib/components/date-picker.umd";

export default {
    name: "export-sale-invoice-dialog",
    components: { DatePicker },
    data() {
        return {
            isLoading: false,
            manager: null,
            client: null,
            invoiceDate: "",
            arrivalDate: "",
            payrollDate: "",
            previousId: null
        };
    },
    async mounted() {
        await this.getFrequentlyUsedQueries({ users: true, export_clients: true });
        document.addEventListener("keydown", this.handleKeyboardListener);
        this.previousId = this.activeExportInvoice.id;
        this.manager = this.users.find(x => x.id === this.activeExportInvoice.manager_id);
        this.client = this.export_clients.find(x => x.id === this.activeExportInvoice.client_id);
        if (this.activeExportInvoice.invoice_date)
            this.invoiceDate = moment(this.activeExportInvoice.invoice_date, "DD.MM.YYYY").toDate();
        if (this.activeExportInvoice.arrival_date)
            this.arrivalDate = moment(this.activeExportInvoice.arrival_date, "DD.MM.YYYY").toDate();
        if (this.activeExportInvoice.payroll_date)
            this.payrollDate = moment(this.activeExportInvoice.payroll_date, "DD.MM.YYYY").toDate();
    },
    computed: {
        ...mapState(["export_clients", "users"]),
        ...mapState("ExportSaleInvoiceStore", ["exportInvoiceCloneDialog", "activeExportInvoice"])
    },
    watch: {
        invoiceDate: function(value) {
            Store.commit("ExportSaleInvoiceStore/updateActiveExportInvoiceProperty", {
                prop: "invoice_date",
                value: moment(value).format("DD.MM.YYYY")
            });
        },
        arrivalDate: function(value) {
            Store.commit("ExportSaleInvoiceStore/updateActiveExportInvoiceProperty", {
                prop: "arrival_date",
                value: moment(value).format("DD.MM.YYYY")
            });
        },
        payrollDate: function(value) {
            Store.commit("ExportSaleInvoiceStore/updateActiveExportInvoiceProperty", {
                prop: "payroll_date",
                value: moment(value).format("DD.MM.YYYY")
            });
        }
    },
    destroyed() {
        this.handleCancelClick();
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    methods: {
        ...mapActions(["getFrequentlyUsedQueries"]),
        handleKeyboardListener(e) {
            if (e.keyCode === 27 || e.key === "Escape") this.handleCancelClick();
            if (document.activeElement.tagName !== "INPUT" && (e.keyCode === 13 || e.key === "Enter")) {
                this.handleCloneClick();
            }
        },
        handleCancelClick() {
            Store.commit("ExportSaleInvoiceStore/setExportInvoiceCloneDialog", false);
            Store.commit("ExportSaleInvoiceStore/setActiveExportInvoice", {});
        },
        handleCloneClick() {
            Store.dispatch("ExportSaleInvoiceStore/createDuplicate", this.activeExportInvoice);
            this.handleCancelClick();
        },
        saveManagerInfo() {
            Store.commit("ExportSaleInvoiceStore/updateActiveExportInvoiceProperty", {
                prop: "manager_id",
                value: this.manager ? this.manager.id : null
            });
        },
        saveClientInfo() {
            Store.commit("ExportSaleInvoiceStore/updateActiveExportInvoiceProperty", {
                prop: "client_name",
                value: this.client.name ? this.client.name : this.client
            });
        },
        updateField(value, field) {
            Store.commit("ExportSaleInvoiceStore/updateActiveExportInvoiceProperty", { prop: field, value: value });
        }
    }
};
</script>

<style scoped></style>
